"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBodyLayoutHeaderSection = exports.StyledBodyLayout = exports.StyledBodyLayoutContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const StackView_1 = require("../../StackView");
exports.StyledBodyLayoutContent = (0, styled_components_1.default)(StackView_1.StackView) `
    flex: 1;
    align-items: stretch;
    > [data-body-content="true"], * > [data-body-content="true"] {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
    }
    > [data-typo='true']:first-child, > *:first-child > [data-typo='true']:first-child  {
        margin-top ${({ theme }) => `${theme === null || theme === void 0 ? void 0 : theme.spacing.s}`};
    }
    > [data-h1='true']:first-child  {
        margin-bottom: ${({ theme }) => `${theme === null || theme === void 0 ? void 0 : theme.spacing.xl}`};
    }
    > [data-toolbar='true']:first-child > * > [data-eat-indent='true']:first-child, 
    > *:first-child > [data-toolbar='true']:first-child > * > [data-eat-indent='true']:first-child, 
    [data-grid-body-layout='true']:first-child > * > [data-eat-indent='true']:first-child,
    > *:first-child > [data-grid-body-layout='true']:first-child > * > [data-eat-indent='true']:first-child  {
        margin-top: ${({ theme }) => `-${theme === null || theme === void 0 ? void 0 : theme.spacing.s}`};
    }
`;
exports.StyledBodyLayout = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative;
    overflow: hidden;
    flex: 1;
    align-self: stretch;
`;
exports.StyledBodyLayoutHeaderSection = (0, styled_components_1.default)(StackView_1.StackView) `
    padding: ${({ theme }) => `0 ${theme === null || theme === void 0 ? void 0 : theme.spacing.m}`};
`;
//# sourceMappingURL=BodyLayout.styles.js.map